import * as React from 'react';

export default class Thumbview extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="files/small-thumbnails/active" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
       <g id="thumbView" stroke="#878787">
          <g id="files-display-icon"></g>
          <g id="Group-32" transform="translate(1.000000, 1.000000)">
              <path d="M7.52393691,1.71428571 L13.8896537,1.71428571" id="Line" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M4,0 L5,0 C5.55228475,-1.01453063e-16 6,0.44771525 6,1 L6,5 C6,5.55228475 5.55228475,6 5,6 L4,6 L4,0 Z" id="selected" stroke="none" fill="#17B9F0"></path>
              <path d="M7.48713576,4 L12.0083961,4" id="Line-Copy-2" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
              <rect id="Rectangle-14" stroke="" x="0.5" y="0.5" width="5" height="5" rx="1"></rect>
          </g>
          <g id="Group-32-Copy" transform="translate(1.000000, 9.000000)">
              <path d="M7.52393691,1.71428571 L13.8896537,1.71428571" id="Line" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M7.48713576,4 L12.0083961,4" id="Line-Copy-2" stroke="" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M4,0 L5,0 C5.55228475,-1.01453063e-16 6,0.44771525 6,1 L6,5 C6,5.55228475 5.55228475,6 5,6 L4,6 L4,0 Z" id="selected" stroke="none" fill="#17B9F0"></path>
              <rect id="Rectangle-14" stroke="" x="0.5" y="0.5" width="5" height="5" rx="1"></rect>
          </g>
          </g>
      </g>
      </svg>
    )
  }
}
